/**
 * Shared logins that must never be treated as MaaS coordinators (werfleiding), no matter which roles they hold.
 *
 * Field workers all sign in with one shared account that carries `DomainAdministrator`, and
 * `GlobalEventsService.getRoles()` expands that role into every role - `MaasCoordinator` included, mirroring
 * `RolesHelper.GetAllRoles` on the backend. Without this list the shared account is offered the coordinator choice
 * dialog on every setup and a coordinator entry point in the header. See SMAAS-70.
 *
 * This list withholds the coordinator user interface only; it does not change the roles or rights an account holds.
 * Entries MUST be lower case, the comparison is case-insensitive.
 */
export const nonCoordinatorAccounts: readonly string[] = ["dagrapporten.markeringen@signco.be"];
